class SwiperSlide {
    constructor() {
        this.events();
    }
    events() {
      this.slidesectionFistSwiper()
      this.swiperSlideCar()
      this.slideSection6()
      this.slideSection7()
      this.slideSection8()
      this.slideOperate9()
    }
    slidesectionFistSwiper(){
      var slidesectionFistSwiper = new Swiper(".sectionFistSwiper", {
        spaceBetween: 0 ,
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination-section-first",
          clickable: true,
        },
      });
    }
    swiperSlideCar(){
      var swiperSlideCar = new Swiper(".slide-vehicles", {
        
        speed:1000,
        slidesPerView: 4,
        spaceBetween: 20,
    
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.slide-vehicles-wrapper .swiper-button-next',
            prevEl: '.slide-vehicles-wrapper .swiper-button-prev',
          },
        breakpoints: {
            992: {
                slidesPerView: 4,
             
            },
            991: {
                slidesPerView: 3.2,
            },
            768: {
                slidesPerView: 2,
                
              },
            0:{
                slidesPerView: 1,
                
                spaceBetween: 0,
            }
           
          },
    });
    }
    slideSection6(){
      var slideSection6 = new Swiper(".slide-section6", {
        pagination: {
          el: ".slide-section6 .swiper-pagination",
          clickable: true,
        },
      });
    }
    slideSection7(){
      var slideSection7 = new Swiper(".slide-section7", {
        pagination: {
          el: ".slide-section7 .swiper-pagination",
          clickable: true,
        },
      });
    }
    slideSection8(){
      var slideSection8 = new Swiper(".slide-section8", {
        slidesPerView: 2.2 ,
         spaceBetween: 30,
        slideToClickedSlide: true,
        pagination: {
          el: ".slide-section8 .swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1025: {
              slidesPerView: 2.2,
              spaceBetween: 20,
          },
          768:{
            slidesPerView: 2,
          },
          481:{
            slidesPerView: 2,
            spaceBetween: 15,
          },
          0:{
              slidesPerView: 1.2,
              spaceBetween: 10,
          }
         
        },
      });
    }
    slideOperate9(){
      var slideOperateThumbs = new Swiper('.operate-thumbs', {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 3.2,
        freeMode: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        breakpoints: {
          1025: {
              slidesPerView: 3.2,
              spaceBetween: 20,
          },
          768:{
            slidesPerView: 2.8,
          },
          481:{
            slidesPerView: 2.5,
            spaceBetween: 15,
          },
          0:{
              slidesPerView: 1.5,
              spaceBetween: 10,
          }
         
        },
      });
      var slideOperateTop = new Swiper('.operate-top', {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.section-9__bottom-content .swiper-button-next',
          prevEl: '.section-9__bottom-content .swiper-button-prev',
        },
        thumbs: {
          swiper: slideOperateThumbs,
        },
      });
      var slideOperateBottom = new Swiper('.operate-bottom', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: false,
        
      });
     
      slideOperateTop.controller.control = slideOperateBottom;
    }
}
export default SwiperSlide
